export const PRIMARY = '#FFCE05';
export const SECONDARY = "#14172C";
export const DARKER = '#0C0E1E';
export const BOX_SHADOW = "0px 0px 14px #806704;";
export const BG_GAMES = '#05050A';
export const SUCCESS = '#1FB404';